import { BehaviorSubject } from "rxjs";

const showModalTopClient = new BehaviorSubject(false);
const showModalCreditClient = new BehaviorSubject(false);

export const modalService = {
  modalState: showModalTopClient.asObservable(),
  open: () => showModalTopClient.next(true),
  close: () => showModalTopClient.next(false),
};

export const modalCreditClient = {
  modalState: showModalCreditClient.asObservable(),
  open: () => showModalCreditClient.next(true),
  close: () => showModalCreditClient.next(false),
};